module.exports = "<nav id='vertical-nav'>\n  <ul>\n    <ng-content></ng-content>\n  </ul>\n</nav>\n"